var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import typography, { convertFromUxLangToCss } from '../Typography';
import WixComponent from '../BaseComponents/WixComponent';

/**
  * a regular html `<label>` element but in wix style
  */

var Label = function (_WixComponent) {
  _inherits(Label, _WixComponent);

  function Label() {
    _classCallCheck(this, Label);

    return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
  }

  _createClass(Label, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          appearance = _props.appearance,
          id = _props.id,
          children = _props.children,
          forAttr = _props.for;

      var className = typography[convertFromUxLangToCss(appearance)];
      return React.createElement(
        'label',
        { className: className, id: id, htmlFor: forAttr },
        children
      );
    }
  }]);

  return Label;
}(WixComponent);

Label.displayName = 'Label';

Label.propTypes = {
  /** id of element the label is for */
  for: PropTypes.string,

  /** one of available typography appearances */
  appearance: PropTypes.oneOf(['T1', 'T1.1', 'T1.2', 'T1.3', 'T1.4', 'T2', 'T2.1', 'T2.2', 'T2.3', 'T3', 'T3.1', 'T3.2', 'T3.3', 'T3.4', 'T4', 'T4.1', 'T4.2', 'T4.3', 'T5', 'T5.1']),

  children: PropTypes.any,
  id: PropTypes.string
};

Label.defaultProps = {
  appearance: 'T1.1'
};

export default Label;
//# sourceMappingURL=Label.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Label/Label.js